// @flow
import BaseFilterModel from "../filters/BaseFilterModel";
import createAttribute from "../attributes/_createAttribute";
import { IllegalStateException } from "../../exceptions";

import type { AttributeType, IFilter, ModelOptions } from "../types";

/**
 */
export default class FilterModel extends BaseFilterModel implements IFilter {
  _attribute: AttributeType | null = null;

  /**
   */
  constructor(
    data: Object,
    contributions: Object,
    modelOptions?: ModelOptions,
  ) {
    super(data, contributions, modelOptions);

    this._attribute = this.createAttribute(
      this.type,
      this.param,
      this.data,
      this.contributions,
    );
  }

  /**
   * Create attribute through the attribute factory. Create type based on filter key without the filter suffix
   */
  createAttribute(
    type: string,
    param: string,
    data: Object,
    contributions: Object,
  ): AttributeType | null {
    if (type === "assignment") {
      return null;
    }

    return createAttribute(
      param,
      data,
      {
        ...contributions,
        type: type,
      },
      this.modelOptions,
    );
  }

  /**
   * Get attribute of filter
   */
  get attribute(): AttributeType {
    if (!this._attribute) {
      throw new IllegalStateException(
        `Missing filter attribute on filter model: ${this.label}`,
      );
    }
    return this._attribute;
  }

  /**
   * Retrieve the parameters with it's value for this filter
   */
  get params(): Array<{ name: string, value: ?string }> {
    if (!this.param) {
      return [];
    }

    return [
      {
        name: this.param,
        value: this.attribute?.value,
      },
    ];
  }

  /**
   * Getting the value of the filter
   */
  get value(): string | null {
    return this.attribute?.value;
  }

  /**
   * Getting the inputvalue of the filter
   */
  get inputvalue(): string {
    return this.attribute?.inputvalue;
  }

  /**
   * Indicates if the filter has a value.
   */
  hasValue(): boolean {
    return this.value !== null && this.value !== "";
  }

  /**
   * Reset the value of this filter to undefined
   */
  reset(): FilterModel {
    if (this.attribute) {
      this.attribute.reset();
    }

    return this;
  }

  /**
   * Update this filter with input name and value
   */
  update(attribute: AttributeType, value: string) {
    if (this.attribute) {
      this.attribute.update(value);
    }
  }

  /**
   * Inidiates if filter is active
   */
  isActive(): boolean {
    return this.attribute?.initvalue !== null;
  }

  /**
   * Inidiates if filter is valid
   */
  get isValid(): boolean {
    return this.attribute?.isValid ?? true;
  }

  /**
   */
  get readonlyvalue(): string {
    if (this.attribute) {
      return this.attribute.readonlyvalue;
    }
    return "";
  }

  /**
   */
  get formdata(): { [string]: any } | null {
    return this.attribute.formdata ?? null;
  }
}
